import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BlogService from '../../api/services/BlogService';
import MainPagetitle from '../../layouts/MainPagetitle';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

const AddBlog = () => {
  const navigate = useNavigate();

  const [file, setFile] = useState()
  const [error, setError] = useState([]);
  const [description, setDescription] = useState("");
  const [Germandescription, setGermanDescription] = useState("");
  useEffect(() => {
    if (localStorage.getItem("admintoken")) {

    }
    else {
      navigate('/')
    }
  }, []);
  const handleEditorChange = (e, editor) => {
    const data = editor.getData()
    setDescription(data);
  }
  const handleGermanEditorChange = (e, editor) => {
    const data = editor.getData()
    setGermanDescription(data);
  }
  const onFileChange = (e) => {
    const fileReader = new FileReader()
    fileReader.readAsDataURL(e.target.files[0])
    fileReader.onload = () => {
      var blog_image = fileReader.result
      setFile(blog_image)
    }
  }
  const onSubmitForm = async (event) => {
    event.preventDefault();
    try {
      var userData = {

        "title": event.target.title.value,
        "de_title": event.target.de_title.value,
        "sub_title": event.target.sub_title.value,
        "de_sub_title": event.target.de_sub_title.value,
        "blog_image": file ? file.split(',')[1] : "",
        "description": description,
        "de_description": Germandescription

      }
      console.log(userData)
      let responseData = await BlogService.store(userData).json()
      if (responseData.status === true) {
        navigate("/admin/blogs");
      }
    } catch (error) {
      if (error.name === 'HTTPError') {
        const errorJson = await error.response.json();
        setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
      }
    }

  };

  return (
    <>
      <MainPagetitle mainTitle="Add Blog" pageTitle={'Add Blog'} parentTitle={'Home'} />
      <div className="container-fluid">
        <form className="form-valide" onSubmit={onSubmitForm}>
          <div className="row">
            <div className="col-xl-12">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Add Blog</h4>
                </div>
                <div className="card-body">
                  <div className="row">

                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >English Title<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='title' id="val-username" placeholder="" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >German Title<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='de_title' id="val-username" placeholder="" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >English Sub Title<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='sub_title' id="val-username" placeholder="" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >German Sub Title<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='de_sub_title' id="val-username" placeholder="" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-number" className="form-label"> Blog Image <span className="text-danger">*</span></label>
                      <img className="img-drop-area" height={file ? 100 : 0} width={file ? 100 : 0} src={file} alt='' />
                      <input type="file" className="form-control" name='blog_image' id="val-number" accept="image/png, image/jpeg" onChange={onFileChange} />
                    </div>

                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-number" className="form-label"> English Blog Description <span className="text-danger">*</span></label>
                      <div className="custom-ekeditor">
                        <CKEditor
                          editor={ClassicEditor}
                          name="description"
                          onChange={handleEditorChange}
                        />
                      </div>
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-number" className="form-label"> German Blog Description <span className="text-danger">*</span></label>
                      <div className="custom-ekeditor">
                        <CKEditor
                          editor={ClassicEditor}
                          name="de_description"
                          onChange={handleGermanEditorChange}
                        />
                      </div>
                    </div>


                  </div>
                  <div className="text-danger mb-2">{error}</div>
                  <div>
                    <button type="submit" className="btn btn-primary me-1">Submit</button>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </form>
      </div>

    </>
  );
};
export default AddBlog;